import { render, staticRenderFns } from "./MarketCardList.vue?vue&type=template&id=86def722&scoped=true&"
import script from "./MarketCardList.vue?vue&type=script&lang=js&"
export * from "./MarketCardList.vue?vue&type=script&lang=js&"
import style0 from "./MarketCardList.vue?vue&type=style&index=0&id=86def722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86def722",
  null
  
)

export default component.exports